import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import AcceleratedCheckinFlow from './AcceleratedCheckInFlow';

const AcceleratedCheckinFlowWrapper = (props) => (
  <Router basename='/'>
    <AcceleratedCheckinFlow {...props} />
  </Router>
);

export default AcceleratedCheckinFlowWrapper;
